<template>
  <div>
    <slot v-for="i in Array(length).keys()" :name="i + 1"></slot>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    props: {
      length: {
        type: Number,
        required: true
      }
    }
  });
</script>